import React, { useState, useEffect, useRef } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import {
  Users,
  Book,
  Building,
  ChevronRight,
  ChevronDown,
  ChevronLeft,
  Menu,
} from "lucide-react";
import SettingOffCanvas from "../../../../components/setting/SettingOffCanvas.js";
import { FaPlus } from "react-icons/fa";
import { cmsNavigation } from "../../../cmsNavigation";
import TopNavbar from "./horizontalNav";
import {
  useGlobalState,
  getGlobalHostelMenuState,
  getGlobalLibraryMenuState,
  getGlobalCanteenMenuState,
  getGlobalTransportMenuState,
} from "../../../../services/hostelConst.js";
import { useParams } from "react-router-dom";
import {
  getOrganizationLevel,
  updateOrganizationLevel,
  deleteOrganizationLevel,
  addOrganizationLevel,
} from "../../../../services/OrganisationServices/organizationLevel";
import {
  showErrorMessages,
  callToast,
  createPathTONavigate,
} from "../../../../services/utilityFunctions";
import { FaPaperPlane } from "react-icons/fa";
import { getLocalStorageData } from "../../../../services/axiosComponent";
const SERVICE_NAME_MAPPING = {
  "User Management": "Users",
  Hostel: "Hostel",
  Organization: "Organization",
  Canteen: "Canteen",
  Library: "Library",
  Parking: "Parking",
  "Fee Management": "Fees",
  Academic: "Academic",
  Transport: "Transport",
  Examination: "Examination",
};
const DualSidebarNavigation = () => {
  const {
    hostelMenuState,
    toggleHostelMenu,
    libraryMenuState,
    toggleLibraryMenu,
    canteenMenuState,
    toggleCanteenMenu,
    transportMenuState,
    toggleTransportMenu,
    isChildSidebarOpen,
    closeChildSidebar,
    openChildSidebar,
    triggerChildSidebar,
  } = useGlobalState();
  const [filteredNavigation, setFilteredNavigation] = useState([]);
  const location = useLocation();
  const currentPath = location.pathname;
  const navigate = useNavigate();
  const [showAddHostelModal, setShowAddHostelModal] = useState(false);
  const [activeMainService, setActiveMainService] = useState(null);
  const [activeSubService, setActiveSubService] = useState(null);
  const [activeSubSubService, setActiveSubSubService] = useState(null);

  const [expandedServices, setExpandedServices] = useState({});
  const [regionOrganizationLevelList, setRegionOrganizationLevelList] =
    useState(null);
  const [siteOrganozaationLevelList, setSiteOrganozaationLevelList] =
    useState(null);
  const SERVICES_WITH_LIST_DETAIL_PATTERN = [
    "Hostel",
    "Library",
    "Canteen",
    "Transport",
  ];
  const menuStates = {
    Hostel: hostelMenuState,
    Library: libraryMenuState,
    Canteen: canteenMenuState,
    Transport: transportMenuState,
  };

  const toggleMenuFunctions = {
    Hostel: toggleHostelMenu,
    Library: toggleLibraryMenu,
    Canteen: toggleCanteenMenu,
    Transport: toggleTransportMenu,
  };
  const getOrganizationLevelList = async (type) => {
    var res = await getOrganizationLevel({ type: type });
    if (res.status == "success") {
      if (type == "REGION") setRegionOrganizationLevelList(res.data);
      if (type == "SITE") setSiteOrganozaationLevelList(res.data);
    } else {
      showErrorMessages({ data: res, navigate });
    }
  };

  useEffect(() => {
    SERVICES_WITH_LIST_DETAIL_PATTERN.forEach((service) => {
      const serviceLower = service.toLowerCase();

      const isListPage =
        currentPath.includes(`/organisation/${serviceLower}`) &&
        (currentPath.endsWith(`/${serviceLower}-list`) ||
          currentPath.endsWith(`/${serviceLower}`));

      const isDetailPage =
        currentPath.includes(`/organisation/${serviceLower}/`) &&
        !currentPath.endsWith(`/${serviceLower}-list`) &&
        !currentPath.endsWith(`/${serviceLower}`);

      const toggleMenu = toggleMenuFunctions[service];
      const menuState = menuStates[service];

      if (isListPage && menuState) {
        toggleMenu(false);
      } else if (isDetailPage && !menuState) {
        toggleMenu(true);
      }
    });
  }, [currentPath]);

  const [selectedIndex, setSelectedIndex] = useState(0);
  const profileDetails = JSON.parse(localStorage.getItem("profileDetails"));
  const userAccessibilities = profileDetails["_ACCESSIBILITIES_"] || [];
  const allowedNavigation = cmsNavigation.filter((nav) =>
    userAccessibilities.some(
      (access) => SERVICE_NAME_MAPPING[access.service] === nav.title
    )
  );
  allowedNavigation.push(cmsNavigation[cmsNavigation.length - 1]); //forms added

  var setSelectedIndexForService = () => {
    var currentPAth = currentPath.split("/");

    allowedNavigation.findIndex((service, index) => {
      if (currentPAth.length <= 2) {
        navigate("/Organisation/Sites", { replace: true });
        setActiveMainService(
          cmsNavigation.find((nav) => nav.title == "Organization")
        );

        setSelectedIndex(0);

        return;
      }
      if (
        (service.title == "Organization" && currentPAth.length < 3) ||
        (service.title == "Organization" &&
          currentPAth[2]?.toLowerCase() == "sites") ||
        currentPAth[2]?.toLowerCase() == "regions"
      ) {
        setActiveMainService(
          cmsNavigation.find((nav) => nav.title == "Organization")
        );

        setSelectedIndex(index);
      } else if (currentPAth[2].toLowerCase() == service.title.toLowerCase()) {
        setActiveMainService(
          cmsNavigation.find((nav) => nav.title == service.title)
        );
        setSelectedIndex(index);
      }
    });
  };
  useEffect(() => {
    getOrganizationLevelList("REGION");
    getOrganizationLevelList("SITE");

    const currentPath = location.pathname;

    setFilteredNavigation(allowedNavigation);

    setSelectedIndexForService();
  }, []);

  var { id } = useParams();
  const params = useParams();

  const handleMainServiceClick = async (service) => {
    setActiveMainService(service);
    const firstSubService = service.subServices[0];
    setActiveSubService(firstSubService);

    if (SERVICES_WITH_LIST_DETAIL_PATTERN.includes(service.title)) {
      const toggleMenu = toggleMenuFunctions[service.title];
      if (toggleMenu) {
        toggleMenu(false);
      }
    }

    triggerChildSidebar(true);
    navigate(firstSubService.path, { replace: true });
  };

  return (
    <>
      {/* <SettingOffCanvas /> */}
      <div className="dual-sidebar-container d-flex">
        <TopNavbar />
        {/* Parent Sidebar */}
        <div
          className="parent-sidebar d-flex flex-column p-3 "
          style={{
            width: "7vw",
            overflowY: "auto",
            overflowX: "hidden",
            height: "100vh",
            maxHeight: "100vh",
            position: "relative",
            zIndex: 1,
            paddingBottom: "120px", // Increased padding
            display: "flex",
            flexDirection: "column",
          }}
        >
          {!isChildSidebarOpen && (
            <button
              className="menu-toggle-btn d-flex align-items-center justify-content-center mb-3"
              onClick={() => triggerChildSidebar(true)}
              style={{
                transform: isChildSidebarOpen
                  ? "translateY(-20px) scale(0.8)"
                  : "translateY(0) scale(1)",
                opacity: isChildSidebarOpen ? 0 : 1,
                pointerEvents: isChildSidebarOpen ? "none" : "auto",
                width: "40px",
                height: "40px",
                border: "none",
                borderRadius: "12px",
                backgroundColor: "rgba(255, 255, 255, 0.1)",
                color: "white",
                transition: "transform 0.3s ease, opacity 0.3s ease",
                margin: "8px auto",
                cursor: "pointer",
                backdropFilter: "blur(8px)",
              }}
            >
              <Menu
                size={18}
                strokeWidth={2}
                style={{
                  transition: "transform 0.2s ease",
                }}
              />
            </button>
          )}
          {filteredNavigation.map((service, index) => (
            <button
              key={service.id}
              onClick={() => {
                setSelectedIndex(index);
                handleMainServiceClick(service);
              }}
              className={`btn d-flex flex-column align-items-center p-2 rounded-2 mb-3 ${
                selectedIndex === index
                  ? "bg-primary text-white"
                  : "bg-transparent text-white"
              }`}
              style={{
                width: "80px",
                height: "55px",
                border: "none",
                transition: "background-color 0.2s ease",
              }}
            >
              <service.icon className="mb-1" size={20} />
              <small
                style={{
                  fontSize: "0.7rem",
                  letterSpacing: "-0.01em",
                  transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                }}
              >
                {service.title}
              </small>
            </button>
          ))}

          <div
            style={{ height: "50px", minHeight: "50px", flexShrink: 0 }}
          ></div>
        </div>
        {/* Child Sidebar */}

        <div
          className={`child-sidebar bg-white shadow ${
            isChildSidebarOpen ? "open" : ""
          }`}
          style={{
            transform: isChildSidebarOpen
              ? "translateX(0)"
              : "translateX(-100%)",
            transition: "transform 0.5s ease-in-out, width 0.5s ease-in-out",
            position: "relative",
            zIndex: 0, // Slides below the parent sidebar
            width: isChildSidebarOpen ? "13vw" : "0",
            overflow: "hidden",
          }}
        >
          <div
            className="child-sidebar-content p-2 ps-0"
            style={{
              opacity: isChildSidebarOpen ? 1 : 0,
              transition: "opacity 0.3s ease-in-out 0.2s", // slight delay to sync with slide
            }}
          >
            <div className="child-sidebar-header d-flex justify-content-between align-items-center pb-3 mb-4 position-relative">
              <h4
                className="m-0 fw-semibold text-dark"
                style={{
                  fontSize: "1.25rem",
                  letterSpacing: "-0.01em",
                  transformOrigin: "left center",
                  transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                }}
              >
                {activeMainService?.title}
              </h4>
              <button
                className="btn btn-icon p-1 rounded-circle hover-scale"
                onClick={() => triggerChildSidebar(!isChildSidebarOpen)}
                style={{
                  transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                  transform: isChildSidebarOpen
                    ? "rotate(0deg)"
                    : "rotate(180deg)",
                }}
              >
                <ChevronLeft
                  size={20}
                  className="text-muted"
                  style={{
                    transition: "transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                    transform: isChildSidebarOpen
                      ? "rotate(0deg)"
                      : "rotate(180deg)",
                  }}
                />
              </button>

              {/* Animated underline */}
              <div
                className="position-absolute bottom-0 start-0 end-0"
                style={{
                  height: "1px",
                  background:
                    "linear-gradient(90deg, transparent 0%, rgba(0,0,0,0.1) 50%, transparent 100%)",
                  animation: "underlineFlow 2s infinite linear",
                  opacity: 0.5,
                }}
              />
            </div>

            <style>{`
  @keyframes underlineFlow {
    0% { background-position: -200% 0; }
    100% { background-position: 200% 0; }
  }

  .btn-icon {
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
  }

  .hover-scale:hover {
    transform: scale(1.05);
    background-color: rgba(0,0,0,0.05);
  }

  .btn-icon:active {
    transform: scale(0.95);
  }

  .child-sidebar-header {
    border-bottom: 1px solid rgba(0,0,0,0.08);
    transition: border-color 0.3s ease;
  }

  .child-sidebar-header:hover {
    border-bottom-color: rgba(0,0,0,0.15);
  }
`}</style>
            {isChildSidebarOpen && (
              <div className="child-sidebar-items" onClick={(e) => {}}>
                {activeMainService?.subServices.map((subService, index) => {
                  const isListDetailService =
                    SERVICES_WITH_LIST_DETAIL_PATTERN.includes(
                      activeMainService.title
                    );
                  const menuState = menuStates[activeMainService.title];
                  if (isListDetailService) {
                    return menuState ? (
                      // For Transport, always show "Vehicles" in sidebar even when on detail page
                      // For other services, hide the first item when on detail page if it matches the main title
                      index === 0 &&
                      activeMainService.title !== "Transport" &&
                      subService.title === activeMainService.title ? null : (
                        <ChildSideBarItem
                          key={subService.id}
                          activeSubService={activeSubService}
                          setActiveSubService={setActiveSubService}
                          regionOrganizationLevelList={
                            regionOrganizationLevelList
                          }
                          siteOrganozaationLevelList={
                            siteOrganozaationLevelList
                          }
                          subService={subService}
                          id={id}
                          getOrganizationLevelList={getOrganizationLevelList}
                          activeMainService={activeMainService}
                          setShowAddHostelModal={setShowAddHostelModal}
                        />
                      )
                    ) : null;
                  } else {
                    return (
                      <ChildSideBarItem
                        key={subService.id}
                        activeSubService={activeSubService}
                        setActiveSubService={setActiveSubService}
                        regionOrganizationLevelList={
                          regionOrganizationLevelList
                        }
                        siteOrganozaationLevelList={siteOrganozaationLevelList}
                        subService={subService}
                        id={id}
                        getOrganizationLevelList={getOrganizationLevelList}
                        activeMainService={activeMainService}
                        setShowAddHostelModal={setShowAddHostelModal}
                      />
                    );
                  }
                })}
              </div>
            )}
          </div>
        </div>

        {/* <SidebarTrigger
          isSidebarOpen={isOpen}
          onToggle={() => setIsOpen(true)}
        /> */}
        <main
          className="main-contenthehe"
          style={{
            width: `calc(100vw - 7vw - ${isChildSidebarOpen ? "13vw" : "0vw"})`,
            overflowX: "hidden",
            transition: "width 0.5s ease-in-out",
          }}
        >
          <div
            className="p-3 pe-0 me-0 pt-3"
            style={{
              maxWidth: "100%",
              overflowX: "hidden",
            }}
          >
            <Outlet />
          </div>
        </main>
      </div>
    </>
  );
};

const ChildSideBarItem = (props) => {
  var navigate = useNavigate();
  const currentPath = useLocation().pathname;
  const params = useParams();
  var id = props.id;
  var activeMainService = props.activeMainService;
  var setActiveSubService = props.setActiveSubService;
  var setShowAddHostelModal = props.setShowAddHostelModal;
  var getOrganizationLevelList = props.getOrganizationLevelList;
  var regionOrganizationLevelList = props.regionOrganizationLevelList;
  var siteOrganozaationLevelList = props.siteOrganozaationLevelList;
  var activeSubService = props.activeSubService;
  const [addInputField, setAddInputField] = useState(false);
  const [expandedServices, setExpandedServices] = useState({});

  const handleSubServiceClick = (subService, mainService) => {
    setActiveSubService(subService);
    // console.log("main service: ", mainService);

    if (
      mainService == "Hostel" &&
      subService.title != "Hostel" &&
      subService.title != "Add Hostel"
    ) {
      // console.log("id from dual side bar: ", id);

      var path = createPathTONavigate(subService.path, params);
      // console.log(path, "path is ii");
      navigate(path, {
        replace: true,
        state: { preventPush: true },
      });
    } else if (mainService == "Hostel" && subService.title == "Add Hostel") {
      // console.log("you're clicking : ", subService.title);
      setShowAddHostelModal(true);
    } else {
      var path = createPathTONavigate(subService.path, params);
      // console.log(path, "path is ii");
      navigate(path, {
        replace: true,
        state: { preventPush: true },
      });
    }

    if (subService.subSubServices?.length > 0) {
      setExpandedServices((prev) => ({
        ...prev,
        [subService.id]: !prev[subService.id],
      }));
    }
  };
  var subService = props.subService;
  const [isDropDownOpen, setIsDropDownOpen] = useState(false);
  return (
    <div
      key={subService.id}
      className="mb-3 position-relative"
      style={{ paddingLeft: "10px" }}
      onClick={(e) => {
        // console.log("clicked meee");
        handleSubServiceClick(subService, activeMainService.title);
        // e.stopPropagation();
      }}
    >
      <button
        onClick={(e) => {
          // e.stopPropagation();
        }}
        className="btn btn-link w-100 text-start p-0 border-0 text-decoration-none d-flex justify-content-between align-items-center p-1 "
        style={{
          color: activeSubService?.id === subService.id ? "#0d6efd" : "#212529",
        }}
      >
        <span
          className="d-flex align-items-center"
          onClick={(e) => {
            // e.stopPropagation();
          }}
        >
          {subService.title}
        </span>
        {subService.subSubServices?.length > 0 && (
          <span
            className="ms-2 text-muted"
            onClick={(e) => {
              // e.stopPropagation();
            }}
          >
            {!subService?.dropDown ? null : isDropDownOpen ? (
              <>
                <button
                  onClick={(e) => {
                    setAddInputField(!addInputField);
                    // e.stopPropagation();
                  }}
                  className="btn btn-link p-0 border-0 text-decoration-none pe-2"
                  style={{
                    color: "#968E8FFF",
                    fontSize: "12px",
                    lineHeight: 1,
                    opacity: 0.8,
                    transition: "opacity 0.2s ease",
                  }}
                >
                  <FaPlus />
                </button>
                <ChevronDown
                  size={14}
                  onClick={(e) => {
                    e.stopPropagation();
                    setIsDropDownOpen(!isDropDownOpen);
                  }}
                />
              </>
            ) : (
              <ChevronRight
                size={14}
                onClick={(e) => {
                  e.stopPropagation();
                  setIsDropDownOpen(!isDropDownOpen);
                }}
              />
            )}
          </span>
        )}
      </button>

      {subService?.dropDown && isDropDownOpen && (
        <OrganizationLevelDropdown
          data={
            subService.type == "REGION"
              ? regionOrganizationLevelList
              : siteOrganozaationLevelList
          }
          addInputField={addInputField}
          type={subService.type}
          dataSetter={getOrganizationLevelList}
          closeInputfield={() => setAddInputField(false)}
        />
      )}
    </div>
  );
};
const OrganizationLevelDropdown = (props) => {
  const navigate = useNavigate();

  var closeInputfield = props.closeInputfield;
  const [addInputField, setAddInputField] = useState(props.addInputField);
  const [editingId, setEditingId] = useState(null);
  const [editValue, setEditValue] = useState("");
  const [loadingItems, setLoadingItems] = useState({});
  const [addLoading, setAddLoading] = useState(false);
  const data = props.data;
  const setData = props.dataSetter;
  const type = props.type;

  const handleDoubleClick = (item, value) => {
    setEditingId(item);
    setEditValue(value);
  };

  const handleEditSave = (e) => {
    if (e.key === "Enter") {
      setEditingId(null);
    }
  };

  const update = async (itemId) => {
    setLoadingItems((prev) => ({ ...prev, [itemId]: true }));
    try {
      const res = await updateOrganizationLevel({
        name: editValue,
        type: type,
        id: editingId._ID,
      });
      if (res.status === "success") {
        await setData(type);
        setEditingId(null);
      } else {
        showErrorMessages({ data: res, navigate });
      }
    } finally {
      setLoadingItems((prev) => ({ ...prev, [itemId]: false }));
    }
  };
  const add = async () => {
    if (editValue === "") {
      return;
    }
    setAddLoading(true);
    var res = await addOrganizationLevel({
      name: editValue,
      type: type,
      organizationId:
        getLocalStorageData("profileDetails")["_ORGANIZATION_"]["_ID"],
    });
    if (res.status == "success") {
      await setData(type);
      callToast("success", "success", "Organization Level Added Successfully");
      setEditValue("");
      closeInputfield();
    } else {
      showErrorMessages({ data: res, navigate });
    }
    setAddLoading(false);
    //ss
  };
  const handleDelete = async (id) => {
    setLoadingItems((prev) => ({ ...prev, [id]: true }));
    try {
      const res = await deleteOrganizationLevel(id);

      if (res.status === "success") {
        await setData(type);
      } else {
        showErrorMessages({ data: res, navigate });
      }
    } finally {
      setLoadingItems((prev) => ({ ...prev, [id]: false }));
    }
  };

  // if (!data) {
  //   return (
  //     <center>
  //       <div
  //         className="spinner-border text-primary spinner-border-sm"
  //         role="status"
  //       >
  //         <span className="sr-only">Loading...</span>
  //       </div>
  //     </center>
  //   );
  // }
  console.log(typeof addInputField);
  return (
    <div className="mt-2 ms-0 p-0">
      {props.addInputField == true ? (
        <div
          className="d-flex align-items-start justify-content-between py-2 px-3"
          style={{
            borderBottom: "1px solid rgba(0,0,0,0.05)",
            cursor: "pointer",
            transition: "all 0.2s ease",
          }}
        >
          <input
            type="text"
            className="form-control form-control-sm"
            value={editValue}
            onChange={(e) => setEditValue(e.target.value)}
            onKeyPress={(e) => {
              if (e.key === "Enter") add();
            }}
            autoFocus
            style={{
              border: "none",
              outline: "none",
              background: "transparent",
              borderBottom: "1px solid #dee2e6",
              boxShadow: "none",
              padding: "4px 0",
              fontSize: "0.875rem",
              transition: "border-color 0.15s ease-in-out",
              width: "100%",
            }}
          />

          {addLoading ? (
            <div
              className="spinner-border spinner-border-sm text-primary ms-2"
              role="status"
              style={{ width: "14px", height: "14px" }}
            >
              <span className="visually-hidden">Loading...</span>
            </div>
          ) : (
            <FaPaperPlane
              className="ms-2"
              style={{
                fontSize: "14px",
                color: "#0d6efd",
                cursor: "pointer",
                transition: "color 0.2s ease",
              }}
              onClick={async () => {
                await add();
              }}
            />
          )}
        </div>
      ) : data.length == 0 ? (
        <div className="text-left text-muted fs-6">No Level</div>
      ) : null}
      {data.map((item, index) => (
        <div
          key={index}
          onDoubleClick={() => handleDoubleClick(item, item.NAME)}
          className="d-flex align-items-start justify-content-between py-2 px-3"
          style={{
            borderBottom: "1px solid rgba(0,0,0,0.05)",
            cursor: "pointer",
            transition: "all 0.2s ease",
          }}
        >
          {editingId?._ID === item._ID ? (
            <input
              type="text"
              className="form-control form-control-sm"
              value={editValue}
              onChange={(e) => setEditValue(e.target.value)}
              onKeyPress={handleEditSave}
              autoFocus
              style={{
                border: "none",
                outline: "none",
                background: "transparent",
                borderBottom: "1px solid #dee2e6",
                boxShadow: "none",
                padding: "4px 0",
                fontSize: "0.875rem",
                transition: "border-color 0.15s ease-in-out",
                width: "100%",
              }}
            />
          ) : (
            <span className="text-secondary" style={{ fontSize: "0.875rem" }}>
              {item.NAME}
            </span>
          )}

          {editingId?._ID === item._ID ? (
            loadingItems[item._ID] ? (
              <div
                className="spinner-border spinner-border-sm text-primary ms-2"
                role="status"
                style={{ width: "14px", height: "14px" }}
              >
                <span className="visually-hidden">Loading...</span>
              </div>
            ) : (
              <FaPaperPlane
                className="ms-2"
                style={{
                  fontSize: "14px",
                  color: "#0d6efd",
                  cursor: "pointer",
                  transition: "color 0.2s ease",
                }}
                onClick={() => {
                  if (editValue !== item.NAME && editValue !== "") {
                    update(item._ID);
                  }
                }}
              />
            )
          ) : loadingItems[item._ID] ? (
            <div
              className="spinner-border spinner-border-sm text-primary ms-2"
              role="status"
              style={{ width: "14px", height: "14px" }}
            >
              <span className="visually-hidden">Loading...</span>
            </div>
          ) : (
            <button
              className="btn btn-link p-0 ms-2"
              onClick={() => handleDelete(item._ID)}
              style={{ color: "#dc3545", fontSize: "0.875rem" }}
            >
              <i className="fas fa-trash-alt"></i>
            </button>
          )}
        </div>
      ))}
    </div>
  );
};

export default DualSidebarNavigation;
